import { CheckOutlined, DownOutlined } from "@ant-design/icons";
import { Link } from "@tanstack/react-router";
import { Badge, Button, Dropdown, Image, MenuProps } from "antd";
import { type ItemType } from "antd/es/menu/interface";
import logo from "assets/paldock_logo-P-dark.svg";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { getHighestTenantRoleGroup, getTenantRoleBadgeColor } from "utils/getTenantRoleBadge.ts";

export const TenantDropdown = ({ collapsed }: { collapsed: boolean }) => {
    const { t: tD } = usePaldockTranslation("ui.tenant-dropdown");
    const { t: tC } = usePaldockTranslation("common");
    const userUtils = useUser();
    const activeTenant = userUtils.getActiveTenant();
    const tenantFaviconSrc = activeTenant?.favicon ? activeTenant.favicon : logo;

    let menuItems = (userUtils
        ?.getAuthenticatedUser()
        ?.tenants?.slice()
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((tenant) => {
            const roleGroup = getHighestTenantRoleGroup(tenant.userRoles?.map((role) => role.name));

            return {
                key: tenant.slug_name,
                label: (
                    <Link to={`/${tenant.slug_name}`}>
                        <div className={`flex items-center gap-2`}>
                            {<div>{tenant.title}</div>}
                            {roleGroup && (
                                <Badge
                                    count={tC(`roles.${roleGroup}`)}
                                    color={getTenantRoleBadgeColor(roleGroup)}
                                    classNames={{
                                        indicator: "!rounded !shadow-none",
                                    }}
                                />
                            )}
                            {tenant.slug_name === activeTenant?.slug_name && <CheckOutlined />}
                        </div>
                    </Link>
                ),
            };
        }) ?? []) as ItemType[];

    menuItems = [
        ...menuItems,
        // {
        //     key: "divider1",
        //     type: "divider",
        // },
        // {
        //     key: "new_tenant",
        //     icon: <PlusOutlined style={{ color: "var(--ds-blue-900)" }} />,
        //     label: t("tenant-dropdown.new_tenant"),
        // },
    ];

    const menu: MenuProps = {
        items: menuItems,
        selectedKeys: [activeTenant?.slug_name || ""],
    };
    return (
        <div className="w-full bg-gray-100 rounded p-[24px]">
            <Dropdown menu={menu} trigger={["click"]} className="w-full">
                {!collapsed ? (
                    <Button
                        type="text"
                        className="flex items-center justify-between w-full m-0 p-0 gap-2 text-[14px]
             !text-gray-800 hover:!text-gray-900 focus:!text-gray-800 active:!text-gray-800
             !bg-transparent hover:!bg-transparent focus:!bg-transparent active:!bg-transparent
             [&_.anticon]:!text-gray-600"
                        aria-haspopup="dialog"
                        aria-expanded="false"
                        aria-controls="team-menu"
                        aria-label="Switch team"
                    >
                        <div className="flex items-center gap-x-3 min-w-0 flex-1">
                            <div className={"w-[25px] h-[33px] shrink-0"}>
                                <Image
                                    src={tenantFaviconSrc}
                                    height={33}
                                    width={26}
                                    className={"object-contain"}
                                    preview={false}
                                    alt={activeTenant?.favicon ? `${activeTenant.title} Favicon` : "Paldock Favicon"}
                                />
                            </div>
                            <span className="truncate" title={activeTenant?.title || tD("select_workspace")}>
                                {activeTenant?.title || tD("select_workspace")}
                            </span>
                        </div>
                        <DownOutlined className="!ms-0 shrink-0" />
                    </Button>
                ) : (
                    <Button
                        type="text"
                        className="w-full m-0 p-0 gap-2 text-[14px] flex flex-col items-center justify-center
             !text-gray-800 hover:!text-gray-900 focus:!text-gray-800 active:!text-gray-800
             !bg-transparent hover:!bg-transparent focus:!bg-transparent active:!bg-transparent
             [&_.anticon]:!text-gray-600"
                        aria-haspopup="dialog"
                        aria-expanded="false"
                        aria-controls="team-menu"
                        aria-label="Switch team"
                    >
                        <div className="w-[25px] h-[33px] flex items-center justify-center">
                            <Image
                                src={tenantFaviconSrc}
                                height={30}
                                width={23}
                                className={"object-contain"}
                                preview={false}
                                alt={activeTenant?.favicon ? `${activeTenant.title} Favicon` : "Paldock Favicon"}
                            />
                        </div>
                        <div className="flex items-center justify-center">
                            <DownOutlined className="!ms-0" />
                        </div>
                    </Button>
                )}
            </Dropdown>
        </div>
    );
};
